var _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayOnce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 726.2965879265092 726.2965879265092",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l726.2966 0l0 726.2966l-726.2966 0l0 -726.2966z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l726.2966 0l0 726.2966l-726.2966 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m95.683876 53.904053l534.92914 309.24408l-534.92914 309.24408z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#666666",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m95.683876 53.904053l534.92914 309.24408l-534.92914 309.24408z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m459.12598 397.54855l129.57483 0l0 342.58267l-129.57483 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#666666",
    d: "m567.4697 662.5486l-23.4375 0l0 -149.34375q-8.46875 8.078125 -22.203125 16.15625q-13.734375 8.0625 -24.671875 12.09375l0 -22.65625q19.671875 -9.2344055 34.375 -22.390656q14.71875 -13.15625 20.828125 -25.515625l15.109375 0l0 191.65628z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayOnce);
export default __webpack_public_path__ + "static/media/play-once.3ebf35492b2d577d1da9f1ec5981139b.svg";
export { ForwardRef as ReactComponent };